import { MediaEntry } from "../../api/LegacyReportsApi";

function Image({ image }: { image: MediaEntry }) {
  return (
    <img
      src={image.famaUrl || image.mediaUrl || ""}
      alt=""
      width={800}
      height={600}
      className="w-full"
    />
  );
}

function isImage(mediaEntry: MediaEntry) {
  return mediaEntry.mediaType === "IMAGE";
}

function LegacyPostMedia({ mediaEntries }: { mediaEntries: MediaEntry[] }) {
  if (!mediaEntries) return null;

  const imageEntries = mediaEntries.filter(isImage);
  const nonImageEntries = mediaEntries.filter((entry) => !isImage(entry));

  function handleImageClick(e: React.MouseEvent, imageUrl: string) {
    e.preventDefault();
  }

  return (
    <div>
      {nonImageEntries.length > 0 && (
        <>
          <div className="mt-2.5 mb-2.5 text-xs tracking-[0.3px] text-slate-500">
            Links & Videos
          </div>
          {nonImageEntries.map((link, index) => (
            <div key={`${link.mediaUrl}-${index}`}>
              <a
                className="mb-1.5 break-words text-blue-600 hover:text-blue-800"
                href={link.mediaUrl || ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.mediaUrl || ""}
              </a>
            </div>
          ))}
        </>
      )}

      {imageEntries.length > 0 && (
        <>
          <div className="mt-2.5 mb-2.5 text-xs tracking-[0.3px] text-slate-500">
            Photos
          </div>
          <div>
            {imageEntries.map((image, index) => (
              <div
                key={`${image.famaUrl || image.mediaUrl}-${index}`}
                className="max-w-full overflow-hidden mb-2.5 rounded-sm box-border print:not-first:max-w-[50%] print:not-first:pb-2.5 print:not-first:mb-0 print:not-first:inline-block print:not-first:odd:pr-1.75 print:not-first:even:pl-1.75"
                onClick={(e) =>
                  handleImageClick(e, image.famaUrl || image.mediaUrl || "")
                }
              >
                <Image image={image} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default LegacyPostMedia;
